import app from 'flarum/forum/app';
import addEventControl from './addEventControl';
import addEventComposer from './addEventComposer';
import addEventDetails from './addEventDetails';
import addHomeEvents from './addHomeEvents';
app.initializers.add('champis-events', () => {
  addEventControl();
  addEventComposer();
  addEventDetails();
  addHomeEvents();
});